import React from 'react';
import { Container, Typography } from '@mui/material';
import Introduction from './components/introduction';
import Definitions from './components/definition';
import PersonalDataCollection from './components/personalDataCollection';
import DireitoTitular from './components/direitoTitular';
import DataStorageInfo from './components/dataStorageInfo';
import DataSecurityInfo from './components/dataSecurityInfo';
import InformationSharing from './components/informationSharing';
import EmployeeResponsibilities from './components/employeeResponsibilities';
import DataSubjectResponsibilities from './components/dataSubjectResponsibilities';
import CookieUsage from './components/cookieUsage';
import PrivacyPolicyUpdate from './components/privacyPolicyUpdate';
import AccessControlRights from './components/accessControlRights';

const LgpdPage: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ paddingTop: 4, paddingBottom: 4 }}>
      <Typography variant="h3" align="left" gutterBottom>
        Política de privacidade e LGPD
      </Typography>
      <Introduction/>
      <Definitions/>
      <PersonalDataCollection/>
      <AccessControlRights />
      <DireitoTitular/>
      <DataStorageInfo />
      <DataSecurityInfo />
      <InformationSharing />
      <EmployeeResponsibilities />
      <DataSubjectResponsibilities />
      <CookieUsage />
      <PrivacyPolicyUpdate />
    </Container>
  );
};

export default LgpdPage;
